import { Box, FlexBox } from "../../../Components/Boxes";
import Icon from "../../../Components/Icons";
import { Text } from "../../../Components/Text";
import { useResponsive } from "../../../Components/Hooks/index";
import { Button, TextBox } from "../../../Components/Input";
import { useContext, useEffect, useMemo, useState } from "react";
import FormDialog from "../../../Components/Modals/FormDialog";
import { AddClientDialog } from "./Profile/Dialogs/AddClient";
import useClientDispatchers from "../../../redux/dispatchers/useClientDispatchers";
import { AuthContext } from "../../../contextAPI's/authContext";
import {
  useClientsPaginationNextPage,
  useGetAllClientsErrorMsgSelector,
  useGetAllClientsSelector,
  useGetAllClientsStatusSelector,
  useGetAllClientsSuccessMsgSelector,
  useMoreClientsLeftInPaginationSelector,
} from "../../../redux/selectors/useClientSelectors";
import * as asyncStates from "../../../redux/constants/asyncStates";
import DataTable from "../../../Components/DataTable";
import { peopleColumns, renderPeopleCard } from "../peopleColumns";
import EmptyState from "../../../Components/NoRecordFound";
import { useFilterTeamsSelector } from "../../../redux/selectors/useTeamSelectors";
import usePermissionsController from "../../../permissions";

export default function Clients({ clientPath = (clientId) => `/team/clients/${clientId}`, hideAdd = false }) {
  // see whether it's desktop size or not
  const isDesktop = useResponsive({ xs: false, sm: true });

  const { addClient } = usePermissionsController();

  //Get all Clients Dispatcher
  const { getAllClients, clearAllErrorMessages, clearAllSuccessMessages, clearAllLocalClients, } =
    useClientDispatchers();

  //Get all Clients Selectors
  const allClients = useGetAllClientsSelector();
  const getAllClientsStatus = useGetAllClientsStatusSelector();
  const moreClientsLeftInPagination = useMoreClientsLeftInPaginationSelector()
  const filteredTeams = useFilterTeamsSelector()

  const nextPage = useClientsPaginationNextPage();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryTimer, setSearchQueryTimer] = useState(null);

  const getAllClientStatus = useMemo(() => {
    return getAllClientsStatus;
  }, [getAllClientsStatus]);

  const [open, setOpen] = useState(false);
  function HandleDialog() {
    setOpen(!open);
  }

  const loadMore = () => {
    getAllClients({
      query: searchQuery,
      startAfter: nextPage,
      teams: filteredTeams?.map(e => e.id),
    });
  }

  const handleQuery = (e) => {
    setSearchQuery(e.target.value);
    if (searchQueryTimer) {
      clearTimeout(searchQueryTimer);
    }

    const timeout = setTimeout(() => {
      getAllClients({
        query: e.target.value,
        teams: filteredTeams?.map(e => e.id),
      });
    }, 500);
    setSearchQueryTimer(timeout);
  };

  const addButton = (
    <Button
      $onClick={() => {
        HandleDialog();
      }}
    >
      <Icon $icon="Add" $color="white"></Icon>
      <Text $color={"white"}>Add</Text>
    </Button>
  );

  //fetching client from database
  useEffect(() => {
    clearAllLocalClients({})
    getAllClients({
      query: searchQuery,
      teams: filteredTeams?.map(e => e.id),
    });
  }, [filteredTeams]);

  return (
    <>
      <FlexBox
        $justifyContent="space-between"
        $width="98%"
        $marginTop={2}
        $marginBottom={2}
      >
        {/* Search box */}
        <TextBox
          $width="40%"
          $hint={"Search ..."}
          $type={"text"}
          $name={"search"}
          $value={searchQuery}
          $onChange={handleQuery}
          $borderRadius="8px"
          $border="1px solid black"
          $trailing={
            <Icon $icon="Search" $size="20px" />
          }
        />
        {addClient && !hideAdd && addButton}
      </FlexBox>

      <Box $width="100%">
        <DataTable
          ariaLabel="Clients"
          columns={peopleColumns("client")}
          rows={allClients}
          getRowKey={(value, index) => value.id ?? index}
          getRowHref={(value) => clientPath(value.id)}
          renderCard={renderPeopleCard("client")}
          loading={getAllClientStatus === asyncStates.PENDING}
          empty={
            getAllClientStatus === asyncStates.SUCCESS && allClients.length < 1 ? (
              <EmptyState action={addClient && !hideAdd ? addButton : null} />
            ) : null
          }
        />
      </Box>

      {moreClientsLeftInPagination && <FlexBox $width="100%" $justifyContent="center" $marginTop="6">
        <Button $onClick={() => {
          loadMore()
        }} >Load More</Button>
      </FlexBox>}

      <FormDialog
        $open={open}
        $handleDialog={HandleDialog}
        $title={"Add Client"}
        $maxWidth="sm"
        $fullWidth
        $fullScreen={!isDesktop}
      >
        <AddClientDialog $handleDialog={HandleDialog} $type="add" />
      </FormDialog>
    </>
  );
}
